import React from "react";
import { QATicketTable, QAReportPage } from "./components";
import { QA_REPORT_FOR } from "../../constants/qaReports";
import UserReport from "../../../Users/pages/UserProfile/components/UserReport";
import MenuTabs from "../../../../../../../components/MenuTabs";
import DisputesTable from "../components/DisputesTable";

const tabs = [
  {
    name: "Disputes",
    component: <DisputesTable disableActions />,
    route: "disputes",
  },
  {
    name: "Quality",
    component: <QATicketTable />,
    route: "evaluations",
  },
  {
    name: "Report",
    component: <QAReportPage type={QA_REPORT_FOR.AGENT} />,
    route: "report",
  },
  {
    name: "Reports availability",
    component: <UserReport />,
    route: "availability",
  },
];

class AgentArea extends React.Component {
  render() {
    return (
      <MenuTabs
        {...this.props}
        tabs={tabs}
        defaultRoute="my-account/agent"
        pathParam="subRoute"
      />
    );
  }
}

export default AgentArea;
